export enum IdleTimeoutType {
  Auto = 'Auto',
  Modal = 'Modal',
  None = 'None',
}

export type IdleRouteConfigType = {
  [key in IdleTimeoutType]?: string[];
};
